export default __webpack_public_path__ + "static/media/left-chevron.3c27f4d3.svg";